/**
 * Computes optimal column widths based on content.
 *
 * @param {string[]} columnKeys - Keys of the object to consider as columns.
 * @param {Array[]} rows - Array of rows (arrays of raw values).
 * @param {number} [minWidth=8] - Minimum width per column.
 * @param {number} [maxWidth=40] - Maximum width per column.
 * @returns {number[]} Column configuration for write-excel-file.
 */
export function computeColumnWidths(
  columnKeys,
  rows,
  minWidth = 8,
  maxWidth = 40
) {
  return columnKeys.map((_, colIndex) => {
    const maxLen = rows.reduce((max, row) => {
      const val = row[colIndex]
      const str = val != null ? val.toString() : ''
      return Math.max(max, str.length)
    }, 0)
    return Math.min(Math.max(maxLen + 2, minWidth), maxWidth)
  })
}
